import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Panel, Button, ButtonToolbar} from 'react-bootstrap';
import Select from 'react-select';
import { defaultRejectHandler, getErrorValue, withDefaultSort } from '../../utils/utility';
import Layout from '../../components/layout/Layout';
import Card from '../../components/card/Card';
import DataTable from '../../components/datatable/DataTable';
import Alert from '../../modal/alert/Alert';
import Thumbnail from '../../components/thumbnail/Thumbnail';
import InputsRangeFilter from '../../components/filter/InputsRangeFilter';
import MaterialOpaqueCreateModal from '../../modal/material_opaque/MaterialOpaqueCreateModal';
import Constants from '../../config/constants';
import MaterialOpaqueEditModal from '../../modal/material_opaque/MaterialOpaqueEditModal';
import OpaqueMaterialDuplicateModal from '../../modal/duplicate/OpaqueMaterialDuplicateModal';
import { COLUMN_STYLE, getColumnStyle } from '../../components/datatable/util';

import {
  clearErrorMaterialOpaque,
  deleteMaterialOpaque,
  listMaterialOpaque,
} from '../../redux/material_opaque/material_actions';

class MaterialOpaquePage extends React.Component {
  constructor(props) {
    super(props);
    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const coefficientColumn = getColumnStyle(COLUMN_STYLE.coefficient);
    const { t } = props;

    this.columns = [
      {
        Header: '',
        accessor: 'thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'name',
        ...getColumnStyle(COLUMN_STYLE.text),
      },
      {
        Header: () => <b>{t('category')}</b>,
        accessor: 'is_public',
        Cell: row => row.value
            ? <span><i className="fas fa-users"/> {t('public')}</span>
            : <span><i className="fas fa-user"/> {t('private')}</span>,
        ...getColumnStyle(COLUMN_STYLE.category),
      },
      {
        Header: () => <b>{t('density')}<br />({t('kg/cubic_m')})</b>,
        accessor: 'density',
        ...coefficientColumn,
        width: 200,
      },
      {
        Header: () => <b>{t('thermal conductivity')}<br />({t('W/sq_m_C')})</b>,
        accessor: 'thermal_conductivity',
        ...coefficientColumn,
      },
      {
        Header: () => <b>{t('specific heat')}<br />({t('kJ/kg℃')})</b>,
        accessor: 'specific_heat',
        ...coefficientColumn,
      },
    ];

    this.state = {
      selectedMaterial: null,
      categoryOption: 'all',
      isShowCreateModal: false,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isShowDuplicateModal: false,
      isShowFilter: false,
      isCreated: false,
      isEdited: false,
      isDuplicated: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isCreating && nextProps.isCreating !== this.props.isCreating && !nextProps.errorMessage) {
      this.setState({ isShowCreateModal: false, isCreated: true });
    }

    if (this.props.isEditing && nextProps.isEditing !== this.props.isEditing && !nextProps.errorMessage) {
      this.setState({ isShowEditModal: false, isEdited: true });
    }

    if (this.props.isDeleting && nextProps.isDeleting !== this.props.isDeleting && !nextProps.errorMessage) {
      this.setState({ isShowDeleteModal: false });
    }

    if (this.props.isDuplicating && nextProps.isDuplicating !== this.props.isDuplicating && !nextProps.errorMessage) {
      this.setState({ isShowDuplicateModal: false, isDuplicated: true });
    }
  }

  renderActionMenu() {
    const { t } = this.props;
    return [
      <li>
        <a
          id="material-opaque-create"
          href="#"
          data-toggle="modal"
          data-target="#create-material-opaque"
          onClick={() => this.setState({ isShowCreateModal: true, isCreated: false })}
        >
          <i className="fas fa-plus-square" />
          <span className="menu-text">{t('create opaque material')}</span>
        </a>
      </li>,
    ];
  }

  updateSortFilter(search, filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.search = search;
    if (filter !== undefined) {
      this.search.filtered = {
        ...this.search.filtered,
        ...filter,
      };
    }

    this.props.listMaterial(
      this.search.pageSize,
      this.search.page,
      withDefaultSort(this.search.sorted),
      this.search.search,
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category],
    );

    this.setState({ categoryOption: category });
  }

  dismissCreateModal() {
    this.props.clearError();
    this.setState({ isShowCreateModal: false });
  }

  dismissEditModal() {
    this.props.clearError();
    this.setState({ isShowEditModal: false });
  }

  dismissDeleteModal() {
    this.props.clearError();
    this.setState({ isShowDeleteModal: false });
  }

  dismissDuplicateModal() {
    this.props.clearError();
    this.setState({ isShowDuplicateModal: false });
  }

  render() {
    const {
      categoryOption,
      selectedMaterial: material,
      isShowCreateModal,
      isShowEditModal,
      isShowDeleteModal,
      isShowDuplicateModal,
    } = this.state;

    const {
      filteredCount,
      isLoading,
      isDeleting,
      isDuplicating,
      errorMessage,
      t,
    } = this.props;

    const breadcrumbItems = [
      { name: t('materials'), path: '/materials' },
      { name: t('opaque material'), path: '/materials/opaque' },
    ];

    const helpConfig = {
      title: t('help'),
      contentUrl: '/html/help_opaque_material.html',
    };

    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={breadcrumbItems}
        renderActionMenu={() => this.renderActionMenu()}
        help={helpConfig}
      >
        <MaterialOpaqueCreateModal
          show={isShowCreateModal}
          isCreated={this.state.isCreated}
          onHide={() => this.dismissCreateModal()}
        />
        <MaterialOpaqueEditModal
          material={material}
          show={isShowEditModal}
          isEdited={this.state.isEdited}
          onHide={() => this.dismissEditModal()}
        />
        <OpaqueMaterialDuplicateModal
          item={material}
          show={isShowDuplicateModal}
          title={t('copy opaque material')}
          label={t('new opaque material name')}
          isDuplicated={this.state.isDuplicated}
          onHide={() => !isDuplicating && this.dismissDuplicateModal()}
        />
        <Alert
          show={isShowDeleteModal}
          onHide={() => !isDeleting && this.dismissDeleteModal()}
          title={t('delete material')}
          body={`${t('do you want to delete')} ${material ? material.name : ''}?`}
          errorMessage={getErrorValue(errorMessage, 'detail')}
          primaryButtonTitle={isDeleting ? `${t('deleting')}...` : t('delete')}
          primaryButtonStyle="danger"
          primaryButtonEnabled={!isDeleting}
          onPrimaryButtonClick={() => this.props.deleteMaterial(material)}
        />
        <h1>{t('opaque material')}</h1>
        <Card padding={false}>
          <div className="filter-box" style={{ display: 'flex', padding: 20, marginBottom: 20 }}>
            <input
              className="text-search"
              id="material-opaque-search-name"
              style={{ width: 240, height: 36, margin: 10 }}
              type="text"
              onChange={event => this.updateSortFilter(event.target.value, undefined,null, categoryOption)}
              placeholder={t('search name')}
            />
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              style={{ width: 160, margin: 10 }}
              value={categoryOption}
              placeholder={t('category')}
              onChange={option => this.updateSortFilter(this.search.search, this.search.filtered, null, option.value)}
              options={[
                { value: 'all', label: t('all') },
                { value: 'public', label: t('public') },
                { value: 'private', label: t('private') },
              ]}
            />
            <ButtonToolbar style={{ width: 160, marginLeft: 10, marginRight: 10, marginBottom: 10 }}>
              <Button style={{ height: '100%'}} onClick={() => this.setState({ isShowFilter: !this.state.isShowFilter })}>
                {t('filter')}
              </Button>
            </ButtonToolbar>
          </div>
          <Panel id="filter-panel" expanded={this.state.isShowFilter}>
            <Panel.Collapse>
              <Panel.Body>
                <div className="filter-box" style={{ display: 'flex' }}>
                  <InputsRangeFilter
                    style={{ marginLeft: 10, marginRight: 10 }}
                    title={`${t('density')} (${t('kg/cubic_m')})`}
                    minPlaceholder="500"
                    maxPlaceholder="1200"
                    onApplyFilter={(min, max) => this.updateSortFilter(this.search.search, ({density: {min, max}}),null, categoryOption)}
                  />
                  <InputsRangeFilter
                    style={{ marginLeft: 10, marginRight: 10 }}
                    title={`${t('thermal conductivity')} (${t('w/mc')})`}
                    minPlaceholder="0.4"
                    maxPlaceholder="0.9"
                    onApplyFilter={(min, max) => this.updateSortFilter(this.search.search, ({thermal_conductivity: {min, max}}),null, categoryOption)}
                  />
                  <InputsRangeFilter
                    style={{ marginLeft: 10, marginRight: 10 }}
                    title={`${t('specific heat')} (${t('kJ/kg℃')})`}
                    minPlaceholder="0.7"
                    maxPlaceholder="1.1"
                    onApplyFilter={(min, max) => this.updateSortFilter(this.search.search, ({specific_heat: {min, max}}),null, categoryOption)}
                  />
                </div>
              </Panel.Body>
            </Panel.Collapse>
          </Panel>
          <DataTable
            columns={this.columns}
            data={this.props.materials}
            onActionEdit={item => this.setState({ isShowEditModal: true, selectedMaterial: item.original, isEdited: false })}
            onActionDuplicate={item => this.setState({ isShowDuplicateModal: true, selectedMaterial: item.original, isDuplicated: false })}
            onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedMaterial: item.original })}
            filteredCount={filteredCount}
            isLoading={isLoading}
            onFetchData={state => this.updateSortFilter(this.search.search, undefined, state, categoryOption)}
          />
        </Card>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  materials: state.material.opaque.orderedIds.map(id => state.material.opaque.materials[id]),
  filteredCount: state.material.opaque.filteredCount,
  isLoading: state.material.opaque.isLoading,
  isCreating: state.material.opaque.isCreating,
  isEditing: state.material.opaque.isEditing,
  isDeleting: state.material.opaque.isDeleting,
  isDuplicating: state.material.opaque.isDuplicating,
  errorMessage: state.material.opaque.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  listMaterial: (pageSize, page, sorted, search, filtered, isPublic) =>
    defaultRejectHandler(dispatch(listMaterialOpaque(pageSize, page, sorted, search, filtered, isPublic))),
  deleteMaterial: material => defaultRejectHandler(dispatch(deleteMaterialOpaque(material.id))),
  clearError: () => dispatch(clearErrorMaterialOpaque()),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(MaterialOpaquePage),
);



// WEBPACK FOOTER //
// ./src/pages/material_opaque/MaterialOpaquePage.js